module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "bottom": "",
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_vm._v("apps")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://gene.iobio.io/"
    }
  }, [_vm._v("gene.iobio")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://bam.iobio.io/"
    }
  }, [_vm._v("bam.iobio")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('a', {
    attrs: {
      "href": "http://vcf.iobio.io/"
    }
  }, [_vm._v("vcf.iobio")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1a6d6ee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/AppsMenu.vue
// module id = 516
// module chunks = 0